import {
    IGestaoAtendimentoAssisTecResponse,
    IFiltroAtendimentos,
    IRetornarUsuarioResponsavelEAcompanhamento,
} from "../../../Interfaces/AssistenciaTecnica/Atendimento/AtendimentoInterfaces";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function ListarAtendimentosAssisTecService(
    requestBody: IFiltroAtendimentos,
    pagina: number,
    SEG_ATENDIMENTOS: string,
    todos?: boolean
) {
    return Service(
        Axios.post<IGestaoAtendimentoAssisTecResponse>(
            `/assistenciatecnica/atendimentos/listarsolicitacoes?PAGINA=${pagina}&SEG_ATENDIMENTOS=${SEG_ATENDIMENTOS}&todos=${
                todos ?? false
            }`,
            requestBody
        )
    );
}

export async function RetornarUsuarioResponsavelEAcompanhamentoServices(
    idCaso: number
) {
    return Service(
        Axios.get<IRetornarUsuarioResponsavelEAcompanhamento>(
            `/home/atendimentos/retornausuarioresponsavelacompanhamento?idCaso=${idCaso}`
        )
    );
}

export async function ExportarExcelAssistenciaTecnicaService(
    SEG_ATENDIMENTOS: string,
    requestBody: IFiltroAtendimentos
) {
    return Service(
        Axios.post<Blob>(
            `/assistenciatecnica/atendimentos/exportarexcelassistenciatecnica?SEG_ATENDIMENTOS=${SEG_ATENDIMENTOS}`,
            requestBody,
            { responseType: "blob" }
        )
    );
}
